import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { GuidanceState } from '~/utils/guidanceTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'GuidanceBadge',
  props: {
    state: { default: 'safe' },
    text: { default: '' },
    type: { default: '' },
    weight: { default: 'semibold' }
  },
  setup(__props: any) {

const props = __props as { state: GuidanceState, text: string, type: string, weight: 'normal' | 'semibold' }



const weightClass = computed(() =>
  props.weight === 'normal' ? 'font-normal' : 'font-semibold'
)

const textColorClass = computed(() => {
  // Admin-driven type wins
  switch (props.type) {
    case 'alert-success': return 'text-guidance-verified'
    case 'alert-warning': return 'text-guidance-warn-text'
    case 'alert-danger':  return 'text-guidance-danger-text'
  }
  // Fallback: derive color from state
  switch (props.state) {
    case 'safe':
    case 'verified':
      return 'text-guidance-verified'
    case 'warn':
    case 'at':
      return 'text-guidance-warn-text'
    case 'danger':
      return 'text-guidance-danger-text'
    default:
      return 'text-guidance-verified'
  }
})

const icon = computed(() => {
  // Admin-driven type wins. Per Bill: each state has its own color + shape, so
  // danger uses a distinct icon (ban) from warn (exclamation-triangle).
  switch (props.type) {
    case 'alert-success': return 'check-circle'
    case 'alert-warning': return 'exclamation-triangle'
    case 'alert-danger':  return 'ban'
  }
  // Fallback: derive icon from state
  switch (props.state) {
    case 'danger':
      return 'ban'
    case 'warn':
    case 'at':
      return 'exclamation-triangle'
    case 'verified':
    case 'safe':
      return 'check-circle'
    default:
      return null
  }
})

return { __sfc: true,props, weightClass, textColorClass, icon }
}

})